

const HowItWorks = () => {
    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20 pb-20 lg:pb-36">
            
            <div className="flex flex-col tracking-wider py-10">

                <div className="flex w-full justify-center mb-10">
                    <p className="text-base md:text-lg mb-2 mr-5">
                        NFT Owned: <span className = 'text-gray-400'> 23 </span>
                    </p>
                    <p className="text-base md:text-lg mb-2 mr-5">
                        Highest Purchase: <span className = 'text-gray-400'> $5000 </span>
                    </p>
                    <p className="text-base md:text-lg mb-2 mr-5">
                        Joined: <span className = 'text-gray-400'> 23 Sep, 2021 </span>
                    </p>
                </div>

                <div className="shadow-shadow3 bg_gradient py-6 px-3 md:px-10 lg:px-20 rounded-[8px]">
                    <h2 className="mb-20 text-center text-xl lg:text-2xl xl:text-3xl">How It Works</h2>

                    <div className="flex flex-col md:flex-row justify-between items-center mb-16">
                        <div className = 'flex flex-col md:w-[48%] mb-5'>
                            <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Minting An NFT</h2>
                            <p className="text-gray-400 text-sm sm:text-base">
                                Nihil quibusdam eum rem cumque ut. Aut doloremque voluptas itaque dolorem porro sit aut accusantium. Consequatur tenetur consectetur qui soluta molestiae doloribus omnis.
                            </p>
                            <p className="text-gray-400 text-sm sm:text-base">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                            </p>
                            
                        </div>
                        <div className="md:w-[45%] mb-6">
                            <img alt = 'art' className="w-full"
                                src = 'https://images.unsplash.com/photo-1466032454009-878beeedbb3e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' />
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row-reverse justify-between items-center mb-16">
                        <div className = 'flex flex-col md:w-[48%] mb-5'>
                            <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Selling An NFT</h2>
                            <p className="text-gray-400 text-sm sm:text-base">
                                Nihil quibusdam eum rem cumque ut. Aut doloremque voluptas itaque dolorem porro sit aut accusantium. Consequatur tenetur consectetur qui soluta molestiae doloribus omnis.
                            </p>
                            <p className="text-gray-400 text-sm sm:text-base">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                            </p>
                            
                        </div>
                        <div className="md:w-[45%] mb-6">
                            <img alt = 'art' className="w-full"
                                src = 'https://images.unsplash.com/photo-1606498236653-daa6690c21ba?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=855&q=80' />
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row justify-between items-center mb-16">
                        <div className = 'flex flex-col md:w-[48%] mb-5'>
                            <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Minting An NFT</h2>
                            <p className="text-gray-400 text-sm sm:text-base">
                                Nihil quibusdam eum rem cumque ut. Aut doloremque voluptas itaque dolorem porro sit aut accusantium. Consequatur tenetur consectetur qui soluta molestiae doloribus omnis.
                            </p>
                            <p className="text-gray-400 text-sm sm:text-base">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                            </p>
                        </div>
                        <div className="md:w-[45%] mb-6">
                            <img alt = 'art' className="w-full"
                                src = 'https://images.unsplash.com/photo-1653428251066-1a23a29a3c95?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' />
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default HowItWorks;